<template>
  <process-list :singleState='7'/>
</template>

<script>
export default {
	name: "xftdPage",
	components: {
    processList : async () => import('@/components/processList.vue')
  },
	data() {
		return {

		};
	},
	created() {

	},

	mounted() {

	},

};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/pages/fireEngine/fireEngine.vue